


































import { seasonalImages, tawImages } from '@/constants';
import CommonUtils from '@/utils/common-utils';
import DateTimeUtils from '@/utils/date-time-utils';
import moment from 'moment-timezone';

import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Headline extends Vue {
  get currentHomeImageSrc() {
    if (moment().isSameOrAfter(moment('2023-07-01', 'YYYY-MM-DD'))) {
      const current = moment();
      const tawDay = DateTimeUtils.getTawDay(current);

      if (tawDay !== -1) {
        return `https://cdn.planbook.com/${tawImages[tawDay]}`;
      }

      for (var i in this.seasonalImages) {
        const si = this.seasonalImages[i];
        const start = moment(`${si.start} 00:00:00`, 'MM-DD HH:mm:ss');
        const end = moment(`${si.end} 23:59:59`, 'MM-DD HH:mm:ss');

        if (current.isBetween(start, end, null, '[]')) {
          return `https://cdn.planbook.com/${si.src}`;
        }
      }
      return 'https://cdn.planbook.com/images/welcome-home-c.png';
    } else {
      return 'https://cdn.planbook.com/images/seasonal/welcome-home-beta-v12.png';
    }
  }

  get seasonalImages() {
    return seasonalImages;
  }

  signUp() {
    CommonUtils.doSignUp();
  }
}
